import { Color } from '../types';

type ColorType = 'solid' | 'linear' | 'radial';

export function getColorType(color: Color): ColorType {
    if (typeof color === 'string') {
        return 'solid';
    }

    if ('color' in color) {
        return 'solid';
    }

    if (color.type === 'linear') {
        return 'linear';
    }

    if (color.type === 'radial') {
        return 'radial';
    }

    throw new Error('Invalid color shape');
}
